<template>
  <div class="jokes"></div>
</template>
<script>
import eventBus from "../eventBus";
export default {
  name: "Jokes",
  data: function() {
    return {
      slides: []
    };
  },
  mounted() {
    eventBus.$on("JOKES_REQUEST", params => {
      this.onClickGetJokes(params);
    });
  },
  methods: {
    onClickGetJokes: function() {
      fetch(".netlify/functions/jokes", {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          // prettier-ignore
          "Authorization": this.$store.getters["cognito/getIdToken"]()
        }
      })
        .then(response => {
          if (!response.ok) {
            if (response.status === 401) eventBus.$emit("TOKEN_REMOVED", {});
            return {
              status: response.status,
              statusText: response.statusText
            };
          } else {
            return response.json();
          }
        })
        .then(json =>
          json.joke
            ? eventBus.$emit("SLIDE_UPDATED", [
                {
                  id: 0,
                  quote: {
                    icon: "fa fa-theater-masks",
                    caption: "Jokes",
                    text: json.joke
                  },
                  image_r: "jokes.png"
                }
              ])
            : eventBus.$emit("SLIDE_UPDATED", [
                {
                  id: 0,
                  quote: {
                    icon: "fa fa-exclamation-triangle",
                    caption: "Sorry",
                    text:
                      "I don't have any jokes right now, please try again later"
                  },
                  image_r: "jokes.png"
                }
              ])
        )
        .catch(error =>
          eventBus.$emit("SLIDE_UPDATED", [
            {
              id: 0,
              quote: {
                icon: "fa fa-exclamation-triangle",
                caption: "Sorry",
                text: "I don't have any jokes right now, please try again later"
              },
              image_r: "jokes.png"
            }
          ])
        );
    }
  }
};
</script>
<style scoped>
.jokes {
  padding: 0;
  margin: 0;
}
</style>
